module.exports = __webpack_public_path__ + "static/media/national-home-contract-association.37c59281.png";